const { detect } = require('detect-browser');
var { version } = require('@/../package.json');


module.exports = function getBrowserInfo () {
  const browser = detect();
  const scr = window.screen;

  return {
    sdk: {
      version: version,
    },
    browser: {
      name: browser ? browser.name : 'unknown',
      version: browser ? browser.version : 'unknown',
    },
    device: {
      os: browser ? browser.os : 'unknown',
      resolution: scr ? scr.width + 'x' + scr.height : 'unknown',
    },
    viewport: {
      resolution: window.innerWidth + 'x' + window.innerHeight,
    },
  };
}
